import { mapGetters, mapState } from "vuex"

export default {
  computed: {
    ...mapState("lessons", ["voiceSampleProvided"]),
    ...mapGetters({ role: "user/getRole", profile: "profile/getProfile" }),
  },
  methods: {
    getLessonRedirectLink(token, lessonId) {
      const { role: userType } = this
      const lessonPathName = "lesson-video-call-learn-cube"
      const studentLessonUrlName = this.voiceSampleProvided ? lessonPathName : "voice-confirmation"
      const pathName = userType === "teacher" ? lessonPathName : studentLessonUrlName
      const userid = this.profile.id
      const email = this.profile.email
      return {
        name: pathName,
        query: {
          token,
          userType,
          userid,
          lessonId,
          email,
          username: `${this.profile.first_name} ${this.profile.last_name}`,
        },
      }
    },
    getLessonReviewRedirectLink(token, lessonId) {
      const { role: userType } = this
      const lessonPathName = "lesson-video-call-learn-cube"
      const userid = this.profile.id
      const email = this.profile.email
      return {
        name: lessonPathName,
        query: {
          token,
          userType,
          userid,
          lessonId,
          email,
          username: `${this.profile.first_name} ${this.profile.last_name}`,
          review: "true",
        },
      }
    },
  },
}
